<template>
<div>
    <!-- <top-bar></top-bar> -->
    <top-slider></top-slider>
    <top-menu></top-menu>

    <div class="page_content_box">
        <div class="wrap">

            <div class="detail">
                <h1>{{detailContent.title}}</h1>
                <div class="source">
                    <div class="left">
                    <span>发布日期:</span>{{ detailContent.date }}
                    <!-- <span style="margin-left:20px;">来源:</span>{{ detailContent.source !==null ? detailContent.source : '' }} -->
                    </div>
                    <div class="right">
                    <h3>分享到:</h3>
                    <el-popover
                        placement="bottom"
                        width="300"
                        trigger="click">
                        <QRCode :QRtitle="'扫一扫在手机打开当前页'" ></QRCode>
                        <div class="toWx" slot="reference"></div>
                    </el-popover>
                    <div class="toWb" @click="shareWeibo"></div>
                    <div class="toQzone" @click="shareQzone"></div>
                    </div>
                </div>
                <div class="content">
                    <div class="content_detail" v-html="detailContent.content"></div>
                    <div class="file" v-if="showFiles">
                        <h2>附件:</h2>
                        <ul>
                            <li v-for="item in detailContent.files" :key="item.name"><a :href="item.url">{{item.name}}</a></li>
                        </ul>
                    </div>

                    <!-- 我要报名 -->
                    <div class="sign_up_box" v-show="showForm">
                        <h2>我要报名</h2>
                        <el-form :model="form" ref="form" label-width="100px" class="dynamic_form_veteran" :rules="rules">
                            <el-form-item v-for="(item, index) in form.itemLists" :label="item.name" :key="index" :prop="'itemLists.' + index + '.value'" :rules="{ required: true, message: '不能为空', trigger: 'blur'}">
                                <el-input v-model="item.value" v-if="item.type==='text' && item.name!=='手机号'"></el-input>
                                <el-date-picker :type="item.type" placeholder="选择日期" v-model="item.value" v-if="item.type==='time' || item.type==='date' || item.type==='year' || item.type==='month'"></el-date-picker>
                                <el-radio-group v-model="item.value" v-if="item.type=='radio'">
                                    <el-radio :label="radio.label" v-for="(radio,index) in item.options" :key="index"></el-radio>
                                </el-radio-group>
                                <el-checkbox-group v-model="item.value" v-if="item.type=='checkbox'">
                                    <el-checkbox :label="checkbox.label" v-for="(checkbox,index) in item.options" :key="index">{{checkbox.label}}</el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item v-if="showPhone" label="手机号" prop="mobile">
                                <el-input v-model="form.mobile" placeholder="手机号" maxlength="11"></el-input>
                            </el-form-item>
                            <el-form-item v-if="showCode" label="验证码" class="verCode_item" prop="code">
                                <el-input v-model="form.code" placeholder="验证码" class="input_code"></el-input>
                                <div class="getCode" v-show="!oCount.showCountDown" @click="getCode">获取验证码</div>
                                <div class="countDown" v-show="oCount.showCountDown">{{oCount.count}}秒后重新获取</div>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="onSubmit('form')">报名</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                    <!-- 二维码 -->
                    <QRCode :QRtitle="'扫一扫在手机打开当前页'" ></QRCode>
                </div>
            </div>
        </div>
    </div>
    <Footer></Footer>
</div>
</template>

<script>
import { getVeteranDetail,updateTrain,getSmsCode } from '@/service/api.js'
import { dateFormat, createContentMeta } from '@/utils/util.js'
import { vPhone } from '@/utils/Validate.js'
import TopMenu from '@/components/TopMenu.vue'
// import TopBar from '@/components/TopBar.vue'
import Footer from '@/components/Footer.vue'
import TopSlider from '@/components/TopSlider.vue'
import {encrypt} from "../../utils/jsencrypt"
import QRCode from '@/components/QRCode.vue'
export default {
    // components: { TopMenu,TopBar,Footer,TopSlider, QRCode },
    components: { TopMenu,Footer,TopSlider, QRCode },
    data() {
        return {
            showPhone:false,
            showForm:false,
            showCode:false,
            detailParams: {
                id:0,
            },
            detailContent:{
                title:'',
                date:'',
                content:'',
                files:[],
            },
            showFiles:false,
            form:{
                itemLists:[],
                code:'',
                mobile:''
            },
            oCount:{
                showCountDown:false,
                count:'',
                timer:null,
            },
            saveParams:[],
            rules: {
                mobile: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { validator: vPhone, required: true, trigger: 'blur' }
                ],
                code: [
                    { required: true, message: '请输入验证码', trigger: 'blur' }
                ],
            },
        }
    },
    methods: {
        onSubmit(formName) {
            this.$refs[formName].validate((valid) => {
            if (valid) {
                this.saveParams=[];
                for (let i = 0; i < this.form.itemLists.length; i++) {
                    let temp = {};
                    temp.name = this.form.itemLists[i].name
                    temp.eName = this.form.itemLists[i].eName
                    temp.value = this.form.itemLists[i].value
                    this.saveParams.push(temp)
                }
                if (this.form.mobile) {
                    let temp = {};
                    temp.name = '手机号'
                    temp.eName = 'ShouJiHao'
                    temp.value = this.form.mobile
                    this.saveParams.push(temp)
                }
                updateTrain(this.saveParams,this.$route.params.id,this.form.code).then(data=>{
                    if (data.code !==0) {
                        this.$message.error(data.msg)
                    }else{
                        this.$message.success('报名成功')
                        if (data.token) {
                            localStorage.setItem('token',data.token)
                            this.$router.push({name:'PersonalTrain'})
                        }else{
                            this.$router.push({name:'Home'})
                        }
                    }
                })

            } else {
                console.log('error submit!!');
                return false;
            }
            });
        },
        getCode(){
            this.$refs.form.validateField('mobile',(error) => {
                if (error) {
                    console.log('mobile',error);
                }else{
                    const TIME_COUNT = 60;
                    if (!this.oCount.timer) {
                        this.oCount.count = TIME_COUNT;
                        this.oCount.showCountDown = true;
                        this.oCount.timer = setInterval(() => {
                            if (this.oCount.count > 0 && this.oCount.count <= TIME_COUNT) {
                                this.oCount.count--;
                            } else {
                                this.oCount.showCountDown = false;
                                clearInterval(this.oCount.timer);
                                this.oCount.timer = null;
                            }
                        }, 1000)
                    }
                    getSmsCode({mobile: encrypt(''+this.form.mobile)}).then(data=>{
                        if (data.code!==0) {
                            this.$message.error(data.msg)
                        }else{
                            console.log(data);
                        }
                    })
                }
            })
        },
        // 分享到新浪微博
        shareWeibo (event) {
        event.preventDefault()
        // shareUrl是微博的分享地址，（有资料说需要真实的appkey，必选参数，这里我没用appkey也可以正常分享）
        var _shareUrl = 'http://service.weibo.com/share/share.php?' 
        _shareUrl += 'url=' + encodeURIComponent(location.href) //参数url设置分享的内容链接
        _shareUrl += '&title=' + encodeURIComponent(this.detailContent.title) //参数title设置分享的标题
        // 保留当前页面,打开一个非tab页面（按需求来，可以新开标签页，也可以在当前页新开页面）
        window.open(
            _shareUrl,
            '_blank',
            'height=100, width=400',
            'scrollbars=yes,resizable=1,modal=false,alwaysRaised=yes'
        )
        },
        //分享到QQ空间
        shareQzone (event){
        event.preventDefault()
        // shareUrl是微博的分享地址，（有资料说需要真实的appkey，必选参数，这里我没用appkey也可以正常分享）
        var _shareUrl = 'https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?' 
        _shareUrl += 'url=' + encodeURIComponent(location.href) //参数url设置分享的内容链接
        _shareUrl += '&title=' + encodeURIComponent(this.detailContent.title) //参数title设置分享的标题
        // 保留当前页面,打开一个非tab页面（按需求来，可以新开标签页，也可以在当前页新开页面）
        window.open(
            _shareUrl,
            '_blank',
            'height=100, width=400',
            'scrollbars=yes,resizable=1,modal=false,alwaysRaised=yes'
        )
        }
    },
    mounted () {
        this.detailParams.id = parseInt(this.$route.params.id);
        getVeteranDetail('?id='+this.detailParams.id).then(data=>{
            console.log('获取：',data);
            JSON.stringify(data.data.signupData)==='{}' ? this.showForm = false : this.showForm = true
            // 内容展示
            this.detailContent.title = data.data.title;
            this.detailContent.date = dateFormat(data.data.pushTime,'Y年M月D日 H:I');
            this.detailContent.content = data.data.content
            if (data.data.files) {
                this.detailContent.files = JSON.parse(data.data.files)
            }
            if(this.detailContent.files.length>0){
                this.showFiles = true
            }

            // 表单生成
            const nameList = Object.keys(data.data.signupData)
            for (let i = 0; i < nameList.length; i++) {
                let temp = {};
                if (nameList[i]==='手机号') {
                    this.showCode = true
                    this.showPhone = true
                }else{
                    temp.name = nameList[i]
                    temp.eName = data.data.signupData[nameList[i]][nameList[i]].value
                    if(data.data.signupData[nameList[i]][nameList[i]].typeId==='checkbox'){
                        temp.value = []
                    }else{
                        temp.value = ''
                    }
                    temp.type = data.data.signupData[nameList[i]][nameList[i]].typeId
                    temp.options = data.data.signupData[nameList[i]][nameList[i]].options
                    this.form.itemLists.push(temp)
                }
            }
            // 添加meta标签
            let temp = {
                'ColumnName': this.detailContent.title,
                'ColumnType': this.detailContent.title,
                'ArticleTitle': this.detailContent.title,
                'PubDate': this.detailContent.date,
                'ContentSource': this.detailContent.source,
                'Author': this.detailContent.author
            }
            createContentMeta(temp)
            
            console.log(this.form);
        });
    },
}
</script>
<style lang="less">
.dynamic_form_veteran {
    .input_code {
        width: 170px;
    }
    .el-date-editor--date {
        width: 100%;
    }
    .verCodeImg {
        width: 100px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        border: solid 1px #DCDFE6;
        border-radius: 5px;
        display: inline-block;
        vertical-align: middle;
        margin-left: 10px;
        color: #999;
        cursor: pointer;
    }
    .el-button--primary {
        width: 150px;
        height: 40px;
        background-color: #18388b;
        border: none;
    }
}
</style>
<style lang="less" scoped>
.getCode {
    width: 110px;
    height: 40px;
    text-align: center;
    border: solid 1px #DDD;
    background-color: #FFF;
    color: #333;
    border-radius: 5px;
    cursor: pointer;
    display: inline-block;
    vertical-align: top;
    margin-left: 20px;
}
.countDown {
    width: 110px;
    height: 40px;
    text-align: center;
    border: solid 1px #DDD;
    background-color: rgb(218, 218, 218);
    color: #333;
    border-radius: 5px;
    display: inline-block;
    vertical-align: top;
    font-size: 12px;
    margin-left: 20px;
}.sign_up_box {
    width: 500px;
    margin: 40px auto 0;
    h2 {
        font-size: 20px;
        font-weight: 600;
        border-bottom: dashed 1px #DDD;
    }
    .dynamic_form_veteran {
        width: 400px;
        margin: 20px auto 0;
    }
}
.detail {
    padding: 0 50px 50px;
    overflow: hidden;
    min-height: 600px;
    h1 {
        font-size: 24px;
        line-height: 1.4;
        margin-top: 40px;
        text-align: center;
    }
  .source {
    font-size: 14px;
    text-align: center;
    line-height: 1;
    margin-top: 20px;
    color: #999;
    overflow: hidden;
    .left {
      float: left
    }
    .right {
      float: right;
      overflow: hidden;
      h3 {
        float: left;
        line-height: 30px;
      }
      .toWx {
        width: 18px;
        height: 18px;
        float: left;
        cursor: pointer;
        margin-left: 10px;
        margin-top: 5px;
        background: url(../../assets/images/wxShare.png) no-repeat;
        border-radius: 9px;
        &:hover {
          background: url(../../assets/images/wxShare_on.png) no-repeat;
        }
      }
      .toWb {
        width: 18px;
        height: 18px;
        float: left;
        cursor: pointer;
        margin-left: 10px;
        margin-top: 5px;
        background: url(../../assets/images/wbShare.png) no-repeat;
        border-radius: 9px;
        &:hover {
          background: url(../../assets/images/wbShare_on.png) no-repeat;
        }
      }
      .toQzone {
        width: 18px;
        height: 18px;
        float: left;
        cursor: pointer;
        margin-left: 10px;
        margin-top: 5px;
        background: url(../../assets/images/qzoneShare.png) no-repeat;
        border-radius: 9px;
        &:hover {
          background: url(../../assets/images/qzoneShare_on.png) no-repeat;
        }
      }
    }
  }
    .content {
        margin-top: 20px;
        line-height: 2;
        text-align: justify;
        img {
            max-width: 1100px;
        }
    }
    .file {
        margin-top: 20px;
        h2 {
            font-weight: 600;
        }
        ul {
            padding-left: 2em;
            li {
                line-height: 1;
                margin-top: 10px;
                a {
                    color: #18388b;
                    &:hover {
                        text-decoration: underline;
                    }
                }
            }
        }
    }
}
</style>
